/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyTugrik = createReactComponent("outline", "currency-tugrik", "IconCurrencyTugrik", [["path", { "d": "M7 6h10", "key": "svg-0" }], ["path", { "d": "M12 6v13", "key": "svg-1" }], ["path", { "d": "M8 17l8 -3", "key": "svg-2" }], ["path", { "d": "M16 10l-8 3", "key": "svg-3" }]]);

export { IconCurrencyTugrik as default };
//# sourceMappingURL=IconCurrencyTugrik.mjs.map
